const Preloader = () => {
    return (
        <div className="progress">
            <div className="indeterminate"></div>
        </div>
    )
}

export { Preloader }